export default __webpack_public_path__ + "static/media/globe.08191770.svg";